import { isGranted, isUnpaid, lookupUpgrade } from './permissions';
import { AccessRequestResult } from './permissions/result';

/**
 * @param {string} rule
 * @param {{ workspace: *; allowPastDue?: boolean }} payload
 * @param {*|((error: AccessRequestError|undefined, approved: boolean) => void)} [subjectOrCallback]
 * @param {(error: AccessRequestError|undefined, approved: boolean) => void} [callback]
 * @returns {AccessRequestResult}
 */
export const checkRestrictions = (rule, payload, subjectOrCallback, callback) => {
    let subject = subjectOrCallback;

    if (typeof subject === 'function') {
        callback = subject;
        subject = null;
    }

    const billing = payload.workspace.billing || {};
    const granted = isGranted(payload, rule, subject);
    const paid = isUnpaid(billing, payload.allowPastDue) ? isGranted(payload, rule, subject, 'basic') : true;
    const upgrade = granted ? billing.plan : lookupUpgrade(payload, rule, subject);

    const result = new AccessRequestResult(payload, rule, subject, granted, paid, upgrade);

    if (callback) {
        callback(result.error, result.approve);
    }

    return result;
};

export const checkRestrictionsOnAll = (rule, payload, subjects, callback) => {
    for (const subject of subjects) {
        const result = checkRestrictions(rule, payload, subject, callback);

        if (result.error) {
            return false;
        }
    }

    return true;
};

export const checkAllRestrictionsOrThrow = (rules, payload, subject) => {
    if (Array.isArray(rules)) {
        for (const rule of rules) {
            checkAllRestrictionsOrThrow(rule, payload, subject);
        }

        return;
    }

    const check = Array.isArray(subject) ? checkRestrictionsOnAll : checkRestrictions;

    return check(rules, payload, subject, (err) => {
        if (err) {
            throw err;
        }
    });
};

export const checkAllRestrictions = (rules, payload, subject, callback) => {
    if (Array.isArray(rules)) {
        for (const rule of rules) {
            if (!checkAllRestrictions(rule, payload, subject, callback)) {
                return false;
            }
        }

        return true;
    }

    if (Array.isArray(subject)) {
        return checkRestrictionsOnAll(rules, payload, subject, callback);
    }

    return checkRestrictions(rules, payload, subject, callback).approve;
};
